/* eslint-disable jsx-quotes */
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useRouter } from 'next/router';
import Slider from 'react-slick';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
import { formatMoney, trimText } from '../../lib/common';
import { getListJob } from '../../redux/actions/job';
import { getAllServices } from '../../redux/actions/services';
import {
  getListPostHot,
  getListPostNew,
  getPosts,
} from '../../redux/actions/news';
import { getListProjectFeature } from '../../redux/actions/project';
import { getImageOffice } from '../../redux/actions/upload';
import Link from 'next/link';
import { formatCurrency } from '@/utils/currency';

export default function Home(props) {
  const slider = useRef();
  const dispatch = useDispatch();
  const trans = useTrans();
  const [service, setService] = useState([]);
  const slider_feature = useRef();
  const [list_project, setListProject] = useState([]);
  const [list_new, setListNew] = useState([]);
  const [list_new_post, setListNewPost] = useState([]);
  const [total_new_post, setTotalNewPost] = useState();
  const [list_job, setListJob] = useState([]);
  const [list_image_office, setListImageOffice] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);

  // const [countSlider, setCountSlider] = useState(1);
  const [style, setStyle] = useState({});
  const [height, setHeight] = useState(0);
  const refYoutobe = useRef();
  const router = useRouter();
  const refClickYoutobe = useRef();
  useEffect(() => {
    getListProjectFeatureHome(router.locale);
    getListJobSlide();
    getNewHot(router.locale);
    getPostNew(router.locale);
    getListServiceAll();
    getListImageOffice();
  }, [router.locale]);
  const handleClickOut = event => {
    const { target } = event;
    if (
      refYoutobe &&
      refClickYoutobe &&
      refClickYoutobe.current &&
      refYoutobe.current &&
      !refYoutobe.current.contains(target) &&
      !refClickYoutobe.current.contains(target)
    ) {
      setIsShowModal(false);
    }
  };
  useEffect(() => {
    window.addEventListener('click', handleClickOut);
    return () => {
      window.removeEventListener('click', handleClickOut);
    };
  }, []);
  useEffect(() => {
    let scHeight = window.innerHeight;

    if (scHeight < 900) {
      setHeight(scHeight - 70);
    } else {
      setHeight(scHeight - 104);
    }
    // let banner = document.querySelectorAll('.r-big-banner')[0].offsetHeight;
    // let content = document.querySelectorAll('#header')[0].offsetHeight;
    // let rNew = document.querySelectorAll('.r-featured-news')[0].offsetHeight;
    // let padding = (scHeight - banner - content - rNew) / 2;
    // setStyle({
    //   padding: `${padding}px 0px`,
    // });
    // setStyle({
    //   paddingBottom: `${padding}px`,
    //   paddingTop: `25px`
    // });
    // return window.removeEventListener('scroll', handleScroll);
  }, []);
  // const handleScroll = () => {
  //   let scHeight = window.innerHeight;
  //   let banner = document.querySelectorAll('.r-big-banner')[0]?.offsetHeight;
  //   let content = document.querySelectorAll('#header')[0]?.offsetHeight;
  //   let padding = (scHeight - banner - content) / 2;
  //   if (window.scrollY) {
  //     setStyle({
  //       padding: '25px 0px'
  //     });
  //   } else {
  //     setStyle({
  //       paddingBottom: `${padding}px `,
  //       paddingTop: `25px`
  //     });
  //   }
  // };

  const getNewHot = async locale => {
    const data = await getListPostHot({ sign: locale });
    setListNew(data);
  };
  const getListServiceAll = async () => {
    const data = await getAllServices({}, dispatch);

    if (data) {
      setService(data?.rows);
    }
  };
  const getListImageOffice = async () => {
    const data = await getImageOffice();
    setListImageOffice(data);
  };
  const getListJobSlide = async () => {
    const data = await getListJob({ page: 1, limit: 3 }, dispatch);
    if (data) setListJob(data.rows);
  };
  const getPostNew = async locale => {
    const data = await getPosts({ limit: 3, sign: locale });
    if (data) {
      setListNewPost(data.rows);
      // setTotalNewPost(data.total);
    }
  };
  const getListProjectFeatureHome = async locale => {
    const data = await getListProjectFeature({ sign: locale });
    if (data) {
      setListProject(data);
    }
  };
  const stripHtml = html => {
    let tmp = document.createElement('p');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const setting_office = {
    loop: true,
    margin: 30,
    nav: true,
    autoplay: true,
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
  };

  const featured_project = {
    // centerPadding	:50,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 2,
    // prevArrow: false,
    // nextArrow: false,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          // centerPadding	:50,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          // centerPadding	:50,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const formatSalary = item => {
    let sal = `${
      (item?.salary_start === null || item?.salary_start === 0) &&
      item.salary_unit === 2
        ? '$'
        : ''
    }
               ${
                 item?.salary_start === null || item?.salary_start === 0
                   ? ''
                   : formatMoney(Number(item.salary_start))
               }

               `;
    if (item.salary_end && item.salary_end > 0) {
      let sal_end = `${item.salary_unit === 2 ? '$' : ''}${formatMoney(
        Number(item?.salary_end),
      )}${item.salary_unit === 1 ? ' VNĐ' : ''} ${
        item.salary_unit === 3 &&
        (item?.salary_start === null || item?.salary_start === 0)
          ? ' 円 まで'
          : '円'
      }  `;
      sal = `${sal} ${
        item?.salary_start === null || item.salary_start === 0
          ? ' '
          : item.salary_unit === 1
          ? ' VNĐ -'
          : item.salary_unit === 3 && item?.salary_start !== null
          ? ' 円 -'
          : ''
      } ${sal_end}`;
    } else {
      sal = '取引';
    }
    return sal;
  };
  const setting_project_feature = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    // afterChange: currentSlide => {
    //   setCountSlider(currentSlide + 1);
    // },
  };
  const setting_job = {
    loop: false,
    margin: 50,
    infinite: true,
    // autoplay: true,
    speed: 500,
    slidesToShow: 3,
    // autoWidth:true,
    nav: true,
    dots: false,
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <svg
          width={41}
          height={41}
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_400_1139)">
            <path
              d="M20.4414 0.141117C9.39594 0.141115 0.441405 9.09564 0.441403 20.1411C0.441401 31.1866 9.39593 40.1411 20.4414 40.1411C31.4869 40.1411 40.4414 31.1866 40.4414 20.1411C40.4414 9.09565 31.4869 0.141119 20.4414 0.141117ZM20.4414 36.8078C11.2369 36.8078 3.77476 29.3456 3.77476 20.1411C3.77476 10.9366 11.2369 3.47447 20.4414 3.47448C29.6459 3.47448 37.108 10.9366 37.108 20.1411C37.108 29.3456 29.6459 36.8078 20.4414 36.8078Z"
              fill="white"
            />
            <path
              d="M18.2866 10.6293C17.6357 9.9784 16.5804 9.9784 15.9296 10.6293C15.2787 11.2801 15.2787 12.3354 15.9296 12.9863L23.0844 20.1411L15.9295 27.296C15.2787 27.9468 15.2787 29.0021 15.9295 29.653C16.5804 30.3039 17.6357 30.3039 18.2866 29.653L26.6199 21.3196C27.2708 20.6688 27.2708 19.6135 26.6199 18.9626L18.2866 10.6293Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_400_1139">
              <rect
                width={40}
                height={40}
                fill="white"
                transform="translate(0.441406 0.141113)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>
    ),
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Pevious"
        type="button"
      >
        <svg
          width={41}
          height={41}
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_400_1146)">
            <path
              d="M20.4414 40.1411C31.4869 40.1411 40.4414 31.1866 40.4414 20.1411C40.4414 9.09565 31.4869 0.141116 20.4414 0.141115C9.39594 0.141114 0.441413 9.09564 0.441412 20.1411C0.441411 31.1866 9.39594 40.1411 20.4414 40.1411ZM20.4414 3.47447C29.6459 3.47447 37.108 10.9366 37.108 20.1411C37.108 29.3456 29.6459 36.8078 20.4414 36.8078C11.2369 36.8078 3.77477 29.3456 3.77477 20.1411C3.77477 10.9366 11.2369 3.47447 20.4414 3.47447Z"
              fill="white"
            />
            <path
              d="M22.5962 29.653C23.2471 30.3038 24.3024 30.3038 24.9533 29.653C25.6041 29.0021 25.6041 27.9468 24.9533 27.2959L17.7984 20.1411L24.9533 12.9863C25.6041 12.3354 25.6041 11.2801 24.9533 10.6292C24.3024 9.97836 23.2471 9.97836 22.5962 10.6292L14.2629 18.9626C13.612 19.6134 13.612 20.6688 14.2629 21.3196L22.5962 29.653Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_400_1146">
              <rect
                width={40}
                height={40}
                fill="white"
                transform="translate(40.4414 40.1411) rotate(-180)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>
    ),
    // responsive: [
    //   {
    //     breakpoint: 320,
    //     settings: {
    //       slidesToShow: 2,
    //     }
    //   },
    //   {
    //     breakpoint: 1200,
    //     settings: {
    //       slidesToShow: 3,
    //       // margin: 120,
    //     }
    //   }]
  };
  const dataSeo = {
    url: process.env.NEXT_PUBLIC_SEO_URL,
    type: 'website',
    title: 'TCOM JAPAN - ベトナムのトップオフショア開発会社',
    description:
      'TCOM JAPAN - ベトナムの大手オフショア開発会社 TCOM JAPANは、日本におけるベトナムの大手オフショア開発会社です。 優秀なエンジニアのチーム、ソフトウェア開発プロセス、専門的な品質管理により、最高の品質、最適なコストでオフショア サービスを提供します。',
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    card: 'summary_large_image',
  };

  const setting_slide = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    appendDots: dots => {
      return (
        <div
          style={{
            borderRadius: '10px',
            position: 'absolute',
            top: '92%',
            left: '50%',
            transform: 'translateX(-50%)',
            justifyContent: 'center',
          }}
        >
          <ul
            style={{ margin: '0px', display: 'flex', padding: 0 }}
            className="pagi-slick"
          >
            {dots}
          </ul>
        </div>
      );
    },
    customPaging: dots => {
      return <button className="LiSlick-slide"></button>;
    },
  };
  const setting_slide_mb = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
  };
  const slideContent = [
    {
      title:
        'PHP、.Net、Javaによるラボ型のサービスは貴社のテクノロジー リソースの拡大を支援できます。',
      des: ' 最小限のコストで、最短の時間です。',
      img: '/assets/images/other/slide_b.svg',
      img_mb: '/assets/images/other/slide_mb_3.png',
      href: '/offshore',
    },
    {
      title:
        'ベトナム国家レベルの科学技術における名誉ある賞、Sao Khue Award 2023を受賞しました。',
        img_sk: '/assets/images/other/img_prize_2023_en.png',
      des: 'ソフトウェア製品の開発能力でTCOMチームが表彰されました。',
      img: '/assets/images/other/slide_c.svg',
      img_mb: '/assets/images/other/slide_mb_1.png',
      href: 'https://sc.eyefire.vn',
    },

    {
      title: '弊社は最高の品質、最適なコストでオフショアサービスを提供します。',
      des: '貴社の予算に合わせてコスト削減できます。',
      img: '/assets/images/other/slide_3.svg',
      img_mb: '/assets/images/other/slide_mb_2.png',
      href: '/offshore',
    },

    {
      title: 'AI統合CCTVカメラを通じた職場の安全ソリューション',
      img_sk: '/assets/images/other/img_prize_2024_en.png',
      des: 'ソフトウェア製品の開発能力でTCOMチームが表彰されました。 ',
      img: '/assets/images/other/slide_4.svg',
      img_mb: '/assets/images/other/slide_mb_4.png',
      href: '/offshore',
    },

    {
      title: '高精度の顔認識技術のソリューション',
      img_sk: '/assets/images/other/img_prize_2024_en.png',
      des: 'ソフトウェア製品の開発能力でTCOMチームが表彰されました。',
      img: '/assets/images/other/slide_5.svg',
      img_mb: '/assets/images/other/slide_mb_5.png',
      href: '/offshore',
    },
  ];
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className="main-content">
        <div className="r-big-slide r-big-slide-dt">
          <div className="r-big-slide-content">
            <Slider {...setting_slide}>
              {slideContent &&
                slideContent?.map((data, index) => {
                  return (
                    <div className="img-container" key={index}>
                      <div
                        className="img-bg"
                        style={{
                          background: `url("${data.img}") no-repeat 50%`,
                          height: height,
                        }}
                      >
                        <div className="img-content">
                          <h1
                            style={
                              index === 1
                                ? { width: 517 }
                                : index === 0
                                ? { width: 603 }
                                : { width: 652 }
                            }
                          >
                            {data.title}
                          </h1>
                          <img src={data.img_sk} alt="" />
                          <p
                            style={
                              index === 1
                                ? { width: 432 }
                                : // : index === 2
                                  // ? { width: 432 }
                                  {}
                            }
                          >
                            {data.des}
                          </p>
                          <Link href={data.href}>
                            <a
                              target={
                                data.href === 'https://sc.eyefire.vn'
                                  ? '_blank'
                                  : ''
                              }
                            >
                              <p>もっと見る</p>
                              <img src="/assets/images/other/next.svg" alt="" />
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>

        <div className="r-big-slide r-big-slide-mb">
          <div className="r-big-slide-content r-big-slide-content_mb">
            <Slider {...setting_slide_mb}>
              {slideContent &&
                slideContent?.map((data, index) => {
                  return (
                    <div className="img-container img-container_mb" key={index}>
                      <div
                        className="img-bg img-bg_mb"
                        style={{
                          backgroundImage: `url("${data.img_mb}")`,
                        }}
                      >
                        <div className="img-content img-content_mb">
                          <h1
                            style={
                              index === 1
                                ? {}
                                : index === 0
                                ? { width: 238 }
                                : {}
                            }
                          >
                            {data.title}
                          </h1>
                          <img src={data.img_sk} alt="" />
                          <p
                            style={
                              index === 1
                                ? { width: 244 }
                                : index === 0
                                ? { width: 205 }
                                : { width: 211 }
                            }
                          >
                            {data.des}
                          </p>
                          <Link href={data.href}>
                            <a
                              target={
                                data.href === 'https://sc.eyefire.vn'
                                  ? '_blank'
                                  : ''
                              }
                            >
                              <p>もっと見る</p>
                              <img src="/assets/images/other/next.svg" alt="" />
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>

        {/* <div className="r-big-banner r-big-banner-mbs" style={style}>
          <div className="container">
            <div className="content ct-pc">
              <h1
                dangerouslySetInnerHTML={{ __html: trans.home.title_pc }}
              ></h1>
              <p>{trans.home.title_sub}</p>
              <Link href={'/offshore'}>
                <a className="btn-readmore">
                  {trans.home.btn_readmore}
                  <svg
                    width={57}
                    height={29}
                    viewBox="0 0 57 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M55.7729 15.6233C56.0453 15.3509 56.1983 14.9815 56.1983 14.5963C56.1983 14.2111 56.0453 13.8416 55.7729 13.5693L43.4486 1.245C43.1762 0.972615 42.8068 0.819593 42.4216 0.819593C42.0364 0.819593 41.667 0.972614 41.3946 1.245C41.1222 1.51738 40.9692 1.88681 40.9692 2.27202C40.9692 2.65723 41.1222 3.02666 41.3946 3.29904L51.2396 13.1441L2.28799 13.142C2.09702 13.142 1.90791 13.1796 1.73147 13.2527C1.55503 13.3258 1.39471 13.4329 1.25967 13.568C1.12463 13.703 1.01751 13.8633 0.944426 14.0398C0.871342 14.2162 0.833728 14.4053 0.833728 14.5963C0.833728 14.7873 0.871343 14.9764 0.944426 15.1528C1.01751 15.3292 1.12463 15.4896 1.25967 15.6246C1.39471 15.7596 1.55503 15.8668 1.73147 15.9398C1.90791 16.0129 2.09702 16.0505 2.28799 16.0505L51.2396 16.0485L41.3946 25.8935C41.1222 26.1659 40.9692 26.5353 40.9692 26.9205C40.9692 27.3058 41.1222 27.6752 41.3946 27.9476C41.667 28.2199 42.0364 28.373 42.4216 28.373C42.8068 28.373 43.1762 28.22 43.4486 27.9476L55.7729 15.6233Z"
                      fill="white"
                    />
                  </svg>
                  <svg
                    className="icon-mb"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="white" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.125 10.1557C3.125 10.0313 3.17439 9.91211 3.26229 9.8242C3.3502 9.73629 3.46943 9.68691 3.59375 9.68691L14.6497 9.68691L11.6994 6.73753C11.6114 6.64951 11.5619 6.53014 11.5619 6.40566C11.5619 6.28118 11.6114 6.1618 11.6994 6.07378C11.7874 5.98576 11.9068 5.93632 12.0313 5.93632C12.1557 5.93632 12.2751 5.98576 12.3631 6.07378L16.1131 9.82378C16.1568 9.86733 16.1914 9.91905 16.215 9.976C16.2387 10.033 16.2508 10.094 16.2508 10.1557C16.2508 10.2173 16.2387 10.2784 16.215 10.3353C16.1914 10.3923 16.1568 10.444 16.1131 10.4875L12.3631 14.2375C12.2751 14.3256 12.1557 14.375 12.0313 14.375C11.9068 14.375 11.7874 14.3256 11.6994 14.2375C11.6114 14.1495 11.5619 14.0301 11.5619 13.9057C11.5619 13.7812 11.6114 13.6618 11.6994 13.5738L14.6497 10.6244L3.59375 10.6244C3.46943 10.6244 3.3502 10.575 3.26229 10.4871C3.17439 10.3992 3.125 10.28 3.125 10.1557Z"
                      fill="#0063AA"
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <div className="content ct-mb">
              <h1>{trans.home.title_mb}</h1>
              <p>{trans.home.title_sub}</p>
              <Link href={'/offshore'}>
                <a className="btn-readmore">
                  {trans.home.btn_readmore}
                  <svg
                    width={57}
                    height={29}
                    viewBox="0 0 57 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M55.7729 15.6233C56.0453 15.3509 56.1983 14.9815 56.1983 14.5963C56.1983 14.2111 56.0453 13.8416 55.7729 13.5693L43.4486 1.245C43.1762 0.972615 42.8068 0.819593 42.4216 0.819593C42.0364 0.819593 41.667 0.972614 41.3946 1.245C41.1222 1.51738 40.9692 1.88681 40.9692 2.27202C40.9692 2.65723 41.1222 3.02666 41.3946 3.29904L51.2396 13.1441L2.28799 13.142C2.09702 13.142 1.90791 13.1796 1.73147 13.2527C1.55503 13.3258 1.39471 13.4329 1.25967 13.568C1.12463 13.703 1.01751 13.8633 0.944426 14.0398C0.871342 14.2162 0.833728 14.4053 0.833728 14.5963C0.833728 14.7873 0.871343 14.9764 0.944426 15.1528C1.01751 15.3292 1.12463 15.4896 1.25967 15.6246C1.39471 15.7596 1.55503 15.8668 1.73147 15.9398C1.90791 16.0129 2.09702 16.0505 2.28799 16.0505L51.2396 16.0485L41.3946 25.8935C41.1222 26.1659 40.9692 26.5353 40.9692 26.9205C40.9692 27.3058 41.1222 27.6752 41.3946 27.9476C41.667 28.2199 42.0364 28.373 42.4216 28.373C42.8068 28.373 43.1762 28.22 43.4486 27.9476L55.7729 15.6233Z"
                      fill="white"
                    />
                  </svg>
                  <svg
                    className="icon-mb"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="white" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.125 10.1557C3.125 10.0313 3.17439 9.91211 3.26229 9.8242C3.3502 9.73629 3.46943 9.68691 3.59375 9.68691L14.6497 9.68691L11.6994 6.73753C11.6114 6.64951 11.5619 6.53014 11.5619 6.40566C11.5619 6.28118 11.6114 6.1618 11.6994 6.07378C11.7874 5.98576 11.9068 5.93632 12.0313 5.93632C12.1557 5.93632 12.2751 5.98576 12.3631 6.07378L16.1131 9.82378C16.1568 9.86733 16.1914 9.91905 16.215 9.976C16.2387 10.033 16.2508 10.094 16.2508 10.1557C16.2508 10.2173 16.2387 10.2784 16.215 10.3353C16.1914 10.3923 16.1568 10.444 16.1131 10.4875L12.3631 14.2375C12.2751 14.3256 12.1557 14.375 12.0313 14.375C11.9068 14.375 11.7874 14.3256 11.6994 14.2375C11.6114 14.1495 11.5619 14.0301 11.5619 13.9057C11.5619 13.7812 11.6114 13.6618 11.6994 13.5738L14.6497 10.6244L3.59375 10.6244C3.46943 10.6244 3.3502 10.575 3.26229 10.4871C3.17439 10.3992 3.125 10.28 3.125 10.1557Z"
                      fill="#0063AA"
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <div className="r-big-banner-mb d-none">
              <img
                className="banner-sp"
                src="/assets/images/home/bannerJP-mb.png"
              />
            </div>
          </div>
        </div> */}

        <div
          className="r-featured-news"
          style={{
            padding: '25px 0px',
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-4 group-slide-button">
                <h3 className="title">{trans.home.news_hot}</h3>
                <div className="owl-nav">
                  <button
                    onClick={() => slider_feature?.current?.slickPrev()}
                    type="button"
                    role="presentation"
                    className="owl-prev "
                  >
                    <svg
                      width="32"
                      height="33"
                      viewBox="0 0 32 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M27 28.2227C26.824 28.2226 26.6512 28.176 26.499 28.0877L7.499 17.0877C7.34746 16.9998 7.22167 16.8736 7.13423 16.7218C7.0468 16.57 7.00077 16.3978 7.00077 16.2227C7.00077 16.0475 7.0468 15.8754 7.13423 15.7235C7.22167 15.5717 7.34746 15.4456 7.499 15.3577L26.499 4.35766C26.651 4.26968 26.8234 4.22328 26.999 4.2231C27.1746 4.22293 27.3472 4.269 27.4993 4.35668C27.6514 4.44435 27.7778 4.57055 27.8657 4.72256C27.9536 4.87458 27.9999 5.04706 28 5.22266V27.2227C28 27.4879 27.8946 27.7422 27.7071 27.9298C27.5196 28.1173 27.2652 28.2227 27 28.2227ZM2 4.22266H4V28.2227H2V4.22266Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  <button
                    onClick={() => slider_feature?.current?.slickNext()}
                    type="button"
                    role="presentation"
                    className="owl-next"
                  >
                    <svg
                      width="32"
                      height="33"
                      viewBox="0 0 32 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 4.22265C5.17598 4.2227 5.34883 4.26927 5.501 4.35765L24.501 15.3577C24.6525 15.4456 24.7783 15.5717 24.8658 15.7235C24.9532 15.8754 24.9992 16.0475 24.9992 16.2227C24.9992 16.3978 24.9532 16.57 24.8658 16.7218C24.7783 16.8736 24.6525 16.9998 24.501 17.0877L5.501 28.0877C5.34903 28.1756 5.17657 28.222 5.00098 28.2222C4.82538 28.2224 4.65284 28.1763 4.50069 28.0886C4.34855 28.001 4.22218 27.8748 4.13429 27.7227C4.04639 27.5707 4.00008 27.3983 4 27.2227L4 5.22265C4 4.95744 4.10536 4.70308 4.29289 4.51555C4.48043 4.32801 4.73479 4.22265 5 4.22265ZM30 28.2227L28 28.2227L28 4.22266L30 4.22266L30 28.2227Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className="col-12 col-lg-8">
                <div className="news-carousel">
                  <Slider
                    ref={slider_feature}
                    {...setting_project_feature}
                    // {...newSlider}
                  >
                    {/* {list_new?.map((item, index) => {
                      return (
                        <div className="item">
                          <div className="inner">
                            <p>
                              <Link href={`/news/${item.seo_url}`}>
                                <a className="text-white">{item.title}</a>
                              </Link>
                            </p> */}
                            {/* <Link href={`/news/${item.seo_url}`}> */}
                          {/* </div>
                        </div>
                      );
                    })} */}
                  </Slider>
                </div>
                <Link href={'/news'}>
                  <a className="btnNextNews">
                    <svg
                      width={107}
                      height={54}
                      viewBox="0 0 107 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M106.021 29.2021C106.546 28.6774 106.841 27.9659 106.841 27.224C106.841 26.4821 106.546 25.7705 106.021 25.2459L82.2846 1.50921C81.76 0.984598 81.0485 0.689874 80.3065 0.689875C79.5646 0.689876 78.8531 0.984597 78.3285 1.50921C77.8039 2.03382 77.5091 2.74536 77.5091 3.48727C77.5091 4.22919 77.8039 4.94072 78.3285 5.46533L97.2902 24.427L3.00861 24.4231C2.64079 24.4231 2.27657 24.4955 1.93674 24.6363C1.59691 24.777 1.28814 24.9833 1.02805 25.2434C0.76796 25.5035 0.561645 25.8123 0.420883 26.1521C0.28012 26.4919 0.20768 26.8562 0.207678 27.224C0.207676 27.5918 0.280125 27.956 0.420884 28.2959C0.561642 28.6357 0.767962 28.9445 1.02805 29.2045C1.28814 29.4646 1.59691 29.671 1.93674 29.8117C2.27656 29.9525 2.64079 30.0249 3.00861 30.0249L97.2902 30.021L78.3285 48.9827C77.8039 49.5073 77.5091 50.2188 77.5091 50.9607C77.5091 51.7026 77.8039 52.4142 78.3285 52.9388C78.8531 53.4634 79.5646 53.7581 80.3065 53.7581C81.0485 53.7581 81.76 53.4634 82.2846 52.9388L106.021 29.2021Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="r-service">
          <div className="container">
            <div className="top">
              <div className="row">
                <div className="col-12 col-md-10">
                  <div className="title-left">
                    <h3>{trans.home.service_provide}</h3>
                    <p className="desc">{trans.home.service_provide_sub}</p>
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <Link href="/service">
                    <a className="link">
                      <svg
                        width={107}
                        height={54}
                        viewBox="0 0 107 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M106.021 29.2216C106.546 28.697 106.841 27.9854 106.841 27.2435C106.841 26.5016 106.546 25.7901 106.021 25.2655L82.2846 1.52874C81.76 1.00413 81.0485 0.709405 80.3065 0.709406C79.5646 0.709407 78.8531 1.00413 78.3285 1.52874C77.8039 2.05336 77.5091 2.76489 77.5091 3.5068C77.5091 4.24872 77.8039 4.96025 78.3285 5.48486L97.2902 24.4465L3.00861 24.4426C2.64079 24.4426 2.27657 24.515 1.93674 24.6558C1.59691 24.7966 1.28814 25.0029 1.02805 25.263C0.76796 25.5231 0.561645 25.8318 0.420883 26.1717C0.28012 26.5115 0.20768 26.8757 0.207678 27.2435C0.207676 27.6113 0.280125 27.9756 0.420884 28.3154C0.561642 28.6552 0.767962 28.964 1.02805 29.2241C1.28814 29.4842 1.59691 29.6905 1.93674 29.8312C2.27656 29.972 2.64079 30.0445 3.00861 30.0445L97.2902 30.0405L78.3285 49.0022C77.8039 49.5268 77.5091 50.2383 77.5091 50.9802C77.5091 51.7222 77.8039 52.4337 78.3285 52.9583C78.8531 53.4829 79.5646 53.7776 80.3065 53.7776C81.0485 53.7776 81.76 53.4829 82.2846 52.9583L106.021 29.2216Z"
                          fill="#0063AA"
                        />
                      </svg>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
            <div className="service-list">
              <div className="row">
                {service.length
                  ? service.map(item => {
                      return (
                        <Link
                          className="col-12 col-md-6 col-xl-4"
                          href={`/service/${item?.seo_url}`}
                        >
                          <div className="box">
                            <div className="icon">
                              <img src={item.image} alt="" />
                            </div>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                            <div>
                              <a className="more">
                                続きを読む
                                <svg
                                  width={34}
                                  height={17}
                                  viewBox="0 0 34 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M33.3251 9.27843C33.4885 9.115 33.5803 8.89334 33.5803 8.66221C33.5803 8.43109 33.4885 8.20943 33.3251 8.046L25.9305 0.651442C25.7671 0.488012 25.5454 0.396199 25.3143 0.396199C25.0832 0.396199 24.8615 0.488012 24.6981 0.651442C24.5346 0.814871 24.4428 1.03653 24.4428 1.26766C24.4428 1.49878 24.5346 1.72044 24.6981 1.88387L30.6051 7.79089L1.23413 7.78965C1.11954 7.78965 1.00608 7.81222 0.900212 7.85607C0.794348 7.89992 0.698157 7.9642 0.617132 8.04522C0.536108 8.12625 0.471836 8.22243 0.427986 8.3283C0.384136 8.43416 0.361567 8.54763 0.361567 8.66221C0.361567 8.7768 0.384136 8.89026 0.427986 8.99613C0.471836 9.10199 0.536109 9.19818 0.617134 9.2792C0.698158 9.36023 0.794347 9.4245 0.900211 9.46835C1.00607 9.5122 1.11954 9.53477 1.23413 9.53477L30.6051 9.53354L24.6981 15.4406C24.5346 15.604 24.4428 15.8256 24.4428 16.0568C24.4428 16.2879 24.5346 16.5096 24.6981 16.673C24.8615 16.8364 25.0832 16.9282 25.3143 16.9282C25.5454 16.9282 25.7671 16.8364 25.9305 16.673L33.3251 9.27843Z"
                                    fill="#0063AA"
                                  />
                                </svg>
                              </a>
                            </div>
                          </div>
                        </Link>
                      );
                    })
                  : ''}
              </div>
            </div>
          </div>
        </div>
        <div className="r-reason">
          <div className="container">
            <h3 className="title">{trans.home.reason}</h3>
            <div className="box">
              <div className="group-reason">
                <img src="/assets/images/home/group-reason.png" alt="" />
              </div>
              <ul>
                <li>
                  <div className="icon">
                    <img src="/assets/images/home/r1.png" alt="" />
                  </div>
                  {/* <p>{trans.home.reason_sub1}</p> */}
                  <p
                    dangerouslySetInnerHTML={{ __html: trans.home.reason_sub1 }}
                  ></p>
                </li>
                <li>
                  <div className="icon">
                    <img src="/assets/images/home/r2.png" alt="" />
                  </div>
                  <p>{trans.home.reason_sub2}</p>
                </li>
                <li>
                  <div className="icon">
                    <img src="/assets/images/home/r3.png" alt="" />
                  </div>
                  <div
                    dangerouslySetInnerHTML={{ __html: trans.home.reason_sub3 }}
                  ></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="r-coporate">
          <div className="container">
            <div className="top">
              <h2>{trans.home.method_cooperation}</h2>
              <p>{trans.home.method_cooperation_sub}</p>
              <a href="#" className="link">
                <svg
                  width={107}
                  height={54}
                  viewBox="0 0 107 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M106.021 29.2216C106.546 28.697 106.841 27.9854 106.841 27.2435C106.841 26.5016 106.546 25.7901 106.021 25.2655L82.2846 1.52874C81.76 1.00413 81.0485 0.709405 80.3065 0.709406C79.5646 0.709407 78.8531 1.00413 78.3285 1.52874C77.8039 2.05336 77.5091 2.76489 77.5091 3.5068C77.5091 4.24872 77.8039 4.96025 78.3285 5.48486L97.2902 24.4465L3.00861 24.4426C2.64079 24.4426 2.27657 24.515 1.93674 24.6558C1.59691 24.7966 1.28814 25.0029 1.02805 25.263C0.76796 25.5231 0.561645 25.8318 0.420883 26.1717C0.28012 26.5115 0.20768 26.8757 0.207678 27.2435C0.207676 27.6113 0.280125 27.9756 0.420884 28.3154C0.561642 28.6552 0.767962 28.964 1.02805 29.2241C1.28814 29.4842 1.59691 29.6905 1.93674 29.8312C2.27656 29.972 2.64079 30.0445 3.00861 30.0445L97.2902 30.0405L78.3285 49.0022C77.8039 49.5268 77.5091 50.2383 77.5091 50.9802C77.5091 51.7222 77.8039 52.4337 78.3285 52.9583C78.8531 53.4829 79.5646 53.7776 80.3065 53.7776C81.0485 53.7776 81.76 53.4829 82.2846 52.9583L106.021 29.2216Z"
                    fill="#0063AA"
                  />
                </svg>
              </a>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="box">
                  <img src="/assets/images/home/c1.png" alt="" />
                  <div className="content">
                    <div className="icon">
                      <img
                        src="/assets/images/home/coporate-icon-1.png"
                        alt=""
                      />
                    </div>
                    <div className="inner customPd">
                      <h1>{trans.home.project_based_title}</h1>
                      <p>{trans.home.project_based_description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="box">
                  <img src="/assets/images/home/c2.png" alt="" />
                  <div className="content">
                    <div className="icon">
                      <img
                        src="/assets/images/home/coporate-icon-2.png"
                        alt=""
                      />
                    </div>
                    <div className="inner customPd">
                      <h1 className="customFz">{trans.home.labor_title}</h1>
                      <p>{trans.home.labor_description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="r-process">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-5">
                <div className="col-left">
                  <div className="subtract-2">
                    <img src="/assets/images/home/img1.png" alt="" />
                  </div>
                  <h3>{trans.home.step_active}</h3>
                  {/* <p>{trans.home.step_active_description}</p> */}
                  <div className="subtract">
                    <img src="/assets/images/home/img2.png" alt="" />
                  </div>
                </div>
              </div>
              <div className=" col-md-12 col-lg-7">
                <div className="col-right">
                  <ul>
                    <li>
                      <div className="icon">
                        <svg
                          width="65"
                          height="65"
                          viewBox="0 0 65 65"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="32.9922"
                            cy="32.3555"
                            r="31.5"
                            fill="#0063AA"
                            stroke="white"
                          />
                          <circle
                            cx="32.9922"
                            cy="32.3555"
                            r="28"
                            fill="white"
                          />
                          <path
                            d="M35.2331 39.1803C35.5501 38.718 35.8382 38.3136 36.1408 37.9092C36.3857 37.5192 36.7171 37.1869 37.1061 36.9269C37.4951 36.6669 37.9417 36.4936 38.4027 36.4214C38.8638 36.3491 39.3392 36.3636 39.8003 36.4791C40.2469 36.5947 40.6791 36.7969 41.0393 37.0858C42.3504 37.9958 43.6759 38.9058 45.0014 39.8014C45.7217 40.2347 46.2548 40.9136 46.4565 41.7225C46.6726 42.5314 46.5574 43.3836 46.1396 44.1059C45.7361 44.9581 45.1166 45.7092 44.3386 46.2725C43.5606 46.8359 42.6529 47.197 41.702 47.327C39.3968 47.6448 37.0484 47.327 34.9161 46.4025C31.66 45.1025 28.6777 43.2247 26.1131 40.8558C23.4045 38.4869 21.1282 35.6847 19.3704 32.5647C18.2755 30.6869 17.5263 28.6502 17.1661 26.5124C16.7627 24.6202 17.0652 22.6413 18.0305 20.9513C18.7077 19.8824 19.7594 19.0735 20.9841 18.6979C21.618 18.4812 22.3096 18.4524 22.9579 18.6401C23.6062 18.8279 24.1681 19.2179 24.586 19.7379C25.7386 21.2257 26.7903 22.7568 27.8276 24.2591C28.2743 24.9235 28.4328 25.7324 28.2887 26.5124C28.1446 27.2924 27.7124 28.0002 27.0496 28.4769C26.5598 28.8524 26.0267 29.1991 25.4792 29.6035C28.1446 33.3158 31.4439 36.5514 35.2187 39.1658"
                            fill="#0064AD"
                          />
                          <path
                            d="M40.3909 24.4012H44.8428C45.0733 24.4012 45.2894 24.3146 45.4479 24.1557C45.5055 24.0546 45.5487 23.9535 45.5632 23.8379C45.5776 23.7223 45.5632 23.6212 45.5487 23.5057C45.4767 23.2023 45.1886 23.1157 44.886 23.1157H35.8381C35.7517 23.1157 35.6508 23.1157 35.5644 23.159C35.4779 23.1879 35.4059 23.2457 35.3338 23.3034C35.2762 23.3612 35.2186 23.4479 35.1898 23.5346C35.1609 23.6212 35.1465 23.7079 35.1465 23.7946C35.1465 23.8812 35.1754 23.9679 35.2186 24.0401C35.2618 24.1123 35.3194 24.1846 35.3771 24.2423C35.4491 24.3001 35.5211 24.3434 35.6076 24.3723C35.694 24.4012 35.7805 24.4012 35.8669 24.4012H40.3765H40.3909ZM40.3909 21.7868H44.8428C44.9724 21.8012 45.1165 21.7868 45.2318 21.729C45.347 21.6712 45.4623 21.5845 45.5343 21.4834C45.8225 21.0068 45.5343 20.5012 44.8572 20.5012H35.9534C35.4491 20.5012 35.1465 20.7612 35.1465 21.1368C35.1465 21.5123 35.4491 21.7868 35.9389 21.7868H40.3909ZM40.3909 17.2656H48.0989C48.7904 17.2656 48.9921 17.4534 48.9921 18.1179V26.8568C48.9921 27.4635 48.776 27.6801 48.1421 27.6801H39.5985C39.4544 27.6657 39.3247 27.6801 39.195 27.7668C39.0798 27.839 38.9933 27.9546 38.9501 28.0846C38.5179 29.009 38.0713 29.919 37.639 30.8435C37.5958 30.9879 37.5094 31.1035 37.3797 31.2046C37.2644 31.2913 37.1204 31.3491 36.9619 31.3491C36.8178 31.3491 36.6737 31.3057 36.5441 31.2335C36.4288 31.1468 36.328 31.0313 36.2703 30.9013C35.8381 29.9624 35.3771 29.0524 34.9448 28.1135C34.9016 27.9835 34.8296 27.8679 34.7143 27.8101C34.5991 27.7379 34.4694 27.709 34.3253 27.7379H32.51C32.4091 27.7379 32.3083 27.7379 32.2074 27.709C32.1066 27.6801 32.0201 27.6224 31.9481 27.5501C31.876 27.4779 31.8184 27.3913 31.7896 27.3046C31.7608 27.2179 31.7464 27.1024 31.7608 27.0012V18.0456C31.7608 17.9445 31.7608 17.8434 31.7896 17.7567C31.8184 17.6701 31.876 17.5834 31.9481 17.5112C32.0201 17.439 32.1066 17.3956 32.193 17.3523C32.2939 17.3234 32.3947 17.309 32.4812 17.3234H40.3476V17.2656H40.3909Z"
                            fill="#0064AD"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <p>01</p>
                        <div className="text text-white">
                          <strong>{trans.home.step1}</strong>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <svg
                          width="65"
                          height="65"
                          viewBox="0 0 65 65"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="31.5"
                            fill="#0063AA"
                            stroke="white"
                          />
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="28"
                            fill="white"
                          />
                          <path
                            d="M41.5472 21.7344V32.8559C40.8088 32.5762 39.9883 32.4117 39.1514 32.4117C35.2787 32.4282 32.1444 35.554 32.1444 39.4367C32.1444 43.3194 35.2787 46.4453 39.1514 46.4453C39.9883 46.4453 40.8088 46.2972 41.5472 46.0175V47.3995H19.1807V21.7344H41.5472Z"
                            fill="#0064AD"
                          />
                          <path
                            d="M42.1376 30.9343V20.3886H40.152V18.3814H42.1376V16.3907H19.1475C19.0654 16.3907 18.4418 16.3743 17.7034 16.7362C16.965 17.0653 16.1117 18.0359 16.1445 19.385C16.1445 19.4015 16.1609 19.4015 16.1609 19.4015V46.4485C16.1609 48.4557 18.1465 48.4557 18.1465 48.4557H39.2331C44.1724 48.3899 48.1436 44.392 48.1436 39.44C48.1436 35.508 45.6329 32.1847 42.1376 30.9343ZM20.1485 46.4485V22.3957H40.152V30.4736C39.8238 30.4407 39.4792 30.4078 39.151 30.4078C34.1788 30.4078 30.142 34.455 30.142 39.44C30.142 42.2697 31.4548 44.8033 33.4896 46.4485H20.1485ZM18.9998 20.3721C18.8193 20.3721 18.5731 20.257 18.4254 20.1418C18.2942 19.9937 18.1629 19.895 18.1465 19.385C18.1793 18.7434 18.3434 18.7105 18.6059 18.5295C18.7208 18.4637 18.8849 18.4308 18.9998 18.4143C19.1146 18.3814 19.1475 18.4143 19.1475 18.3814H38.15V20.3886H19.1475C19.1475 20.3886 19.1146 20.3886 18.9998 20.3721ZM41.5468 46.0208C40.8084 46.3005 39.9879 46.4485 39.151 46.4485C35.2783 46.4485 32.144 43.3062 32.144 39.44C32.144 35.5738 35.2783 32.4314 39.151 32.415C39.9879 32.415 40.8084 32.5795 41.5468 32.8592C44.2216 33.8298 46.1251 36.3964 46.1416 39.44C46.1251 42.4671 44.2216 45.0501 41.5468 46.0208Z"
                            fill="#0064AD"
                          />
                          <path
                            d="M42.2852 38.4339C42.3016 38.3023 42.3016 38.1707 42.3016 38.0226C42.3016 37.3481 42.2196 36.5255 41.7437 35.7522C41.6945 35.6535 41.6288 35.5713 41.5468 35.4726C41.0381 34.8474 40.152 34.3867 39.151 34.4196C37.9859 34.3867 37.0013 34.979 36.5418 35.7522C36.0659 36.5255 35.9839 37.3481 35.9839 38.0226C35.9839 38.1707 35.9839 38.3023 36.0003 38.4339H35.147V43.4353H43.1385V38.4339H42.2852ZM40.2832 38.4339H38.0023C38.0023 38.3023 38.0023 38.1542 38.0023 38.0226C37.9859 37.5455 38.0843 37.0684 38.2484 36.8216C38.4289 36.5913 38.5274 36.4597 39.1674 36.4268C39.7909 36.4597 39.8894 36.5913 40.0699 36.8216C40.2176 37.0684 40.316 37.5455 40.316 38.0226C40.316 38.1707 40.3161 38.3023 40.2996 38.4339H40.2832Z"
                            fill="#0064AD"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <p>02</p>
                        <div className="text text-white">
                          <strong>{trans.home.step2}</strong>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <svg
                          width="65"
                          height="65"
                          viewBox="0 0 65 65"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="31.5"
                            fill="#0063AA"
                            stroke="white"
                          />
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="28"
                            fill="white"
                          />
                          <path
                            d="M41.6213 32.0034L30.4429 43.0955C30.0799 43.4595 29.4875 43.4595 29.1053 43.0955L22.6467 36.582C22.2837 36.218 22.2837 35.6241 22.6467 35.2602L24.8633 33.0571C25.2263 32.6931 25.8187 32.6931 26.2009 33.0571L29.7932 36.6778L38.0862 28.4593C38.4493 28.0953 39.0417 28.0953 39.4238 28.4593L41.6213 30.6815C41.9843 31.0647 41.9843 31.6394 41.6213 32.0034ZM32.1436 13.8805C33.1754 13.8805 34.0162 14.7234 34.0162 15.7579C34.0162 16.7924 33.1754 17.6353 32.1436 17.6353C31.1117 17.6353 30.2709 16.7924 30.2709 15.7579C30.2709 14.7234 31.1117 13.8805 32.1436 13.8805ZM43.3983 15.7579H37.1499C37.1499 12.9992 34.9143 10.7578 32.1436 10.7578C29.3729 10.7578 27.1372 12.9992 27.1372 15.7579H20.8888C18.8251 15.7579 17.1436 17.4438 17.1436 19.5128V47.0228C17.1436 49.0918 18.8251 50.7777 20.8888 50.7777H43.3983C45.462 50.7777 47.1436 49.0918 47.1436 47.0228V19.5128C47.1436 17.4438 45.462 15.7579 43.3983 15.7579Z"
                            fill="#0064AD"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <p>03</p>
                        <div className="text text-white">
                          <strong>{trans.home.step3}</strong>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <svg
                          width="65"
                          height="65"
                          viewBox="0 0 65 65"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="31.5"
                            fill="#0063AA"
                            stroke="white"
                          />
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="28"
                            fill="white"
                          />
                          <path
                            d="M43.4297 32.2011L39.5055 24.8261H34.3443L28.7175 30.3607L29.5023 30.9342C30.1009 31.3743 30.8326 31.6143 31.5775 31.6143C32.3224 31.6143 33.054 31.3743 33.6526 30.9342L35.4883 29.5739C35.6878 29.4272 35.9273 29.3471 36.1667 29.3471C36.4061 29.3471 36.6589 29.4272 36.8584 29.5605L42.3256 33.4681L43.4297 32.2011ZM40.7426 35.1351L36.1933 31.881L35.036 32.7346C34.0384 33.4681 32.8279 33.8548 31.5775 33.8548C30.3271 33.8548 29.1166 33.4547 28.1322 32.7346L27.3474 32.1611C27.0813 31.9611 26.8685 31.721 26.7089 31.4276C26.5493 31.1475 26.4562 30.8275 26.4295 30.5074C26.4029 30.1873 26.4561 29.8539 26.5759 29.5605C26.6956 29.2538 26.8685 28.9871 27.1079 28.747L32.7348 23.2124C32.8146 23.1324 32.9077 23.0657 33.0008 22.999L31.8967 22.5056L24.8865 24.5194L20.9757 31.8944L28.079 37.3489L36.4194 39.4028L40.756 35.1351H40.7426ZM50.0409 30.294C49.9478 30.5741 49.8014 30.8408 49.6019 31.0675C49.4023 31.2942 49.1629 31.481 48.8836 31.6143L45.5447 33.2547L43.3898 35.7219L43.3632 35.7486L43.3366 35.7753H43.3233L38.029 40.9898C37.5901 41.4165 37.0047 41.6566 36.3929 41.6566C36.2066 41.6566 36.0204 41.6299 35.8341 41.5899L27.4937 39.5494C27.1878 39.4694 26.8818 39.3361 26.6291 39.136L18.8606 33.1613L15.4154 31.4676C15.136 31.3343 14.8966 31.1475 14.697 30.9208C14.4975 30.6941 14.3512 30.4274 14.258 30.1473C14.1649 29.8539 14.125 29.5605 14.1516 29.2538C14.1783 28.9604 14.2581 28.667 14.4044 28.4003L17.9428 21.7454C18.2221 21.2253 18.701 20.8252 19.273 20.6385C19.845 20.4518 20.4702 20.5051 21.0022 20.7585L24.2214 22.3455L31.2183 20.3451C31.7504 20.1984 32.3091 20.2384 32.8146 20.4518L37.5634 22.5589H39.9179L43.27 20.9185C43.8154 20.6518 44.4407 20.6118 45.0127 20.7985C45.5847 20.9852 46.0635 21.372 46.3429 21.9054L49.8812 28.5603C50.0275 28.827 50.1074 29.1204 50.134 29.4138C50.1606 29.7072 50.134 30.0139 50.0276 30.294M30.9523 43.7504C30.9124 43.8971 30.8458 44.0305 30.766 44.1505C30.6729 44.2705 30.5665 44.3772 30.4335 44.4439C30.3004 44.5239 30.1541 44.5773 30.0078 44.5906C29.8615 44.6039 29.7018 44.5906 29.5555 44.5639L25.219 43.497C24.8732 43.4037 24.5406 43.2436 24.2613 43.0036L21.0156 40.2296C20.7894 40.0296 20.6431 39.7495 20.6298 39.4561C20.6032 39.1627 20.7096 38.8693 20.9091 38.6426C21.1087 38.4159 21.388 38.2825 21.6939 38.2558C21.9999 38.2291 22.2925 38.3358 22.532 38.5226L25.7777 41.2965L30.1142 42.3634C30.4069 42.4301 30.6596 42.6168 30.8192 42.8835C30.9789 43.1369 31.0188 43.4437 30.9523 43.7371V43.7504Z"
                            fill="#0064AD"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <p>04</p>
                        <div className="text text-white">
                          <strong>{trans.home.step4}</strong>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <svg
                          width="65"
                          height="65"
                          viewBox="0 0 65 65"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="31.5"
                            fill="#0063AA"
                            stroke="white"
                          />
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="28"
                            fill="white"
                          />
                          <path
                            d="M35.3435 41.8391H41.7435C42.1655 41.8391 42.5734 42.0084 42.8688 42.3045C43.1642 42.6006 43.333 42.9955 43.333 43.4186C43.333 43.8416 43.1642 44.2365 42.8688 44.5326C42.5734 44.8288 42.1655 44.998 41.7435 44.998H35.3435C34.9216 44.998 34.5136 44.8288 34.2182 44.5326C33.9229 44.2365 33.7541 43.8416 33.7541 43.4186C33.7541 42.9955 33.9229 42.6006 34.2182 42.3045C34.5136 42.0084 34.9216 41.8391 35.3435 41.8391ZM32.1365 24.55H44.9365C45.7805 24.55 46.5963 24.8743 47.2011 25.4666C47.806 26.0589 48.1436 26.8627 48.1436 27.6947V37.129C48.1436 37.9611 47.806 38.7649 47.2011 39.3572C46.5963 39.9495 45.7805 40.2738 44.9365 40.2738H32.1365C31.2926 40.2738 30.4767 39.9354 29.8719 39.3572C29.267 38.7649 28.9295 37.9611 28.9295 37.129V27.6947C28.9295 26.8627 29.267 26.0589 29.8719 25.4666C30.4767 24.8743 31.2785 24.55 32.1365 24.55ZM17.733 40.2738H20.94V37.129H17.733V40.2738ZM17.733 19.8398H25.7365C26.1585 19.8398 26.5664 20.0091 26.8758 20.3052C27.1712 20.6014 27.34 20.9962 27.34 21.4193V43.4327C27.34 43.8557 27.1712 44.2506 26.8758 44.5467C26.5804 44.8429 26.1725 45.0121 25.7365 45.0121H17.733C17.311 45.0121 16.9031 44.8429 16.6077 44.5467C16.3123 44.2506 16.1436 43.8557 16.1436 43.4327V21.4193C16.1436 20.9962 16.3123 20.6014 16.6077 20.3052C16.9031 20.0091 17.311 19.8398 17.733 19.8398Z"
                            fill="#0064AD"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <p>05</p>
                        <div className="text text-white">
                          <strong>{trans.home.step5}</strong>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <svg
                          width="65"
                          height="65"
                          viewBox="0 0 65 65"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="31.5"
                            fill="#0063AA"
                            stroke="white"
                          />
                          <circle
                            cx="32.1436"
                            cy="32.4258"
                            r="28"
                            fill="white"
                          />
                          <path
                            d="M40.8685 40.9977C40.0616 40.9977 39.4186 40.353 39.4186 39.5693C39.4186 38.7856 40.0742 38.1409 40.8685 38.1409C41.6628 38.1409 42.3185 38.7856 42.3185 39.5693C42.3185 40.353 41.6628 40.9977 40.8685 40.9977ZM43.0498 28.8499L45.8993 32.4273H39.4186V28.8499H43.0498ZM23.4186 40.9977C22.6242 40.9977 21.9686 40.353 21.9686 39.5693C21.9686 38.7856 22.6242 38.1409 23.4186 38.1409C24.2129 38.1409 24.8685 38.7856 24.8685 39.5693C24.8685 40.353 24.2129 40.9977 23.4186 40.9977ZM43.0498 26.7136H39.4186V23.8568C39.4186 22.2894 38.1073 21 36.506 21H19.0561C17.4548 21 16.1436 22.2894 16.1436 23.8568V36.7125C16.1436 38.2799 17.4548 39.5693 19.0561 39.5693C19.0561 41.9458 20.9978 43.8545 23.4186 43.8545C25.8394 43.8545 27.781 41.9458 27.781 39.5693H36.506C36.506 41.9458 38.4477 43.8545 40.8685 43.8545C43.2893 43.8545 45.231 41.9458 45.231 39.5693H46.681C47.4879 39.5693 48.1436 38.9246 48.1436 38.1409V33.388C48.1436 32.7686 47.9292 32.1744 47.5635 31.6815L44.2223 27.2951C43.945 26.9412 43.5163 26.7263 43.0624 26.7263"
                            fill="#0064AD"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <p>06</p>
                        <div className="text text-white">
                          <strong>{trans.home.step6}</strong>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="r-technology">
          <div className="container">
            <div className="title-left">
              <h3>{trans.home.tech_language}</h3>
              <p className="desc">{trans.home.tech_language_description}</p>
              {/* <a href='#' className='link'>
                <svg width={107} height={54} viewBox='0 0 107 54' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path fillRule='evenodd' clipRule='evenodd' d='M106.021 29.2216C106.546 28.697 106.841 27.9854 106.841 27.2435C106.841 26.5016 106.546 25.7901 106.021 25.2655L82.2846 1.52874C81.76 1.00413 81.0485 0.709405 80.3065 0.709406C79.5646 0.709407 78.8531 1.00413 78.3285 1.52874C77.8039 2.05336 77.5091 2.76489 77.5091 3.5068C77.5091 4.24872 77.8039 4.96025 78.3285 5.48486L97.2902 24.4465L3.00861 24.4426C2.64079 24.4426 2.27657 24.515 1.93674 24.6558C1.59691 24.7966 1.28814 25.0029 1.02805 25.263C0.76796 25.5231 0.561645 25.8318 0.420883 26.1717C0.28012 26.5115 0.20768 26.8757 0.207678 27.2435C0.207676 27.6113 0.280125 27.9756 0.420884 28.3154C0.561642 28.6552 0.767962 28.964 1.02805 29.2241C1.28814 29.4842 1.59691 29.6905 1.93674 29.8312C2.27656 29.972 2.64079 30.0445 3.00861 30.0445L97.2902 30.0405L78.3285 49.0022C77.8039 49.5268 77.5091 50.2383 77.5091 50.9802C77.5091 51.7222 77.8039 52.4337 78.3285 52.9583C78.8531 53.4829 79.5646 53.7776 80.3065 53.7776C81.0485 53.7776 81.76 53.4829 82.2846 52.9583L106.021 29.2216Z' fill='#0063AA' />
                </svg>
              </a> */}
            </div>
            <div className="top-technology">
              <div className="top-technology-items">
                <div className="col-12 jdquansdbab">
                  <div className="back-end">
                    <h3>Backend</h3>
                    <ul className="kvs012jkfdsj">
                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/php.svg" alt="" />
                        </div>
                        <div className="name djaiqhad">PHP</div>
                      </li>
                      <li className="i2uqsdnan">
                        <div className="icon">
                          <img src="/assets/images/other/net.svg" alt="" />
                        </div>
                        <div className="name djaiqhad">NetCore</div>
                      </li>
                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/java.svg" alt="" />
                        </div>
                        <div className="name djaiqhad">Java</div>
                      </li>
                      <li className="iadahdada">
                        <span></span>
                      </li>

                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/lar.svg" alt="" />
                        </div>
                        <div className="name">Laravel</div>
                      </li>

                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/cs.svg" alt="" />
                        </div>
                        <div className="name">C#</div>
                      </li>

                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/py.svg" alt="" />
                        </div>
                        <div className="name">Python</div>
                      </li>

                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/node.svg" alt="" />
                        </div>
                        <div className="name">NodeJS</div>
                      </li>

                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/go.svg" alt="" />
                        </div>
                        <div className="name">Golang</div>
                      </li>

                      <li>
                        <div className="icon">
                          <img src="/assets/images/other/dj.svg" alt="" />
                        </div>
                        <div className="name">Django</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="box frontend">
                  <h3>FrontEnd</h3>
                  <ul>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/react.svg" alt="" />
                      </div>
                      <div className="name">ReactJS</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/ang.svg" alt="" />
                      </div>
                      <div className="name">Angular</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/nextJS.svg" alt="" />
                      </div>
                      <div className="name">NextJS</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/vue.svg" alt="" />
                      </div>
                      <div className="name">NextJS</div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="box mobility">
                  <h3>Mobility</h3>
                  <ul>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/ard.svg" alt="" />
                      </div>
                      <div className="name">Android</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/ios.svg" alt="" />
                      </div>
                      <div className="name">Ios</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/native.svg" alt="" />
                      </div>
                      <div className="name">React Native</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/fluter.svg" alt="" />
                      </div>
                      <div className="name">Flutter</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/swift.svg" alt="" />
                      </div>
                      <div className="name">Swift</div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="box ai">
                  <h3>AI</h3>
                  <ul>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/ts.svg" alt="" />
                      </div>
                      <div className="name">Tensorflow</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/pytorch.svg" alt="" />
                      </div>
                      <div className="name">Pytorch</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/py.svg" alt="" />
                      </div>
                      <div className="name">Python</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/mar.svg" alt="" />
                      </div>
                      <div className="name">Marchine learning</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/deep.svg" alt="" />
                      </div>
                      <div className="name">Deep learning</div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="box blockchain">
                  <h3>Blockchain</h3>
                  <ul>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/eth.svg" alt="" />
                      </div>
                      <div className="name">Ethereum</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/sm.svg" alt="" />
                      </div>
                      <div className="name">Smart Contract</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/dapp.svg" alt="" />
                      </div>
                      <div className="name">dApps</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/wallet.svg" alt="" />
                      </div>
                      <div className="name">Wallet</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/bn.svg" alt="" />
                      </div>
                      <div className="name">Blockchain Network</div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="box database">
                  <h3>DataBase</h3>
                  <ul>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/mySQL.svg" alt="" />
                      </div>
                      <div className="name">My SQL</div>
                    </li>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/sqls.svg" alt="" />
                      </div>
                      <div className="name">SQL Server</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/redis.svg" alt="" />
                      </div>
                      <div className="name">Redis</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/mongo.svg" alt="" />
                      </div>
                      <div className="name">Mongo</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/GrapQL.svg" alt="" />
                      </div>
                      <div className="name">GraphQL</div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="box backend">
                  <h3>DevOps</h3>
                  <ul>
                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/gitlab.svg" alt="" />
                      </div>
                      <div className="name">Gitlab</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/jen.svg" alt="" />
                      </div>
                      <div className="name">Jenkins</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/docker.svg" alt="" />
                      </div>
                      <div className="name">Docker</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/ku.svg" alt="" />
                      </div>
                      <div className="name">Kubernetes</div>
                    </li>

                    <li>
                      <div className="icon">
                        <img src="/assets/images/other/aws.svg" alt="" />
                      </div>
                      <div className="name">AWS</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="r-featured-project">
          <div className="container">
            <div className="title-left">
              <h3>{trans.home.feature_project}</h3>
              <p className="desc">{trans.home.feature_project_des}</p>
              <Link href={'/project'}>
                <a className="link">
                  <svg
                    width={107}
                    height={54}
                    viewBox="0 0 107 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M106.021 29.2216C106.546 28.697 106.841 27.9854 106.841 27.2435C106.841 26.5016 106.546 25.7901 106.021 25.2655L82.2846 1.52874C81.76 1.00413 81.0485 0.709405 80.3065 0.709406C79.5646 0.709407 78.8531 1.00413 78.3285 1.52874C77.8039 2.05336 77.5091 2.76489 77.5091 3.5068C77.5091 4.24872 77.8039 4.96025 78.3285 5.48486L97.2902 24.4465L3.00861 24.4426C2.64079 24.4426 2.27657 24.515 1.93674 24.6558C1.59691 24.7966 1.28814 25.0029 1.02805 25.263C0.76796 25.5231 0.561645 25.8318 0.420883 26.1717C0.28012 26.5115 0.20768 26.8757 0.207678 27.2435C0.207676 27.6113 0.280125 27.9756 0.420884 28.3154C0.561642 28.6552 0.767962 28.964 1.02805 29.2241C1.28814 29.4842 1.59691 29.6905 1.93674 29.8312C2.27656 29.972 2.64079 30.0445 3.00861 30.0445L97.2902 30.0405L78.3285 49.0022C77.8039 49.5268 77.5091 50.2383 77.5091 50.9802C77.5091 51.7222 77.8039 52.4337 78.3285 52.9583C78.8531 53.4829 79.5646 53.7776 80.3065 53.7776C81.0485 53.7776 81.76 53.4829 82.2846 52.9583L106.021 29.2216Z"
                      fill="#ffffff"
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <div className="featured-project-carousel  customSlickSlider">
              <Slider {...featured_project}>
                {list_project && list_project.length
                  ? list_project.map(item => {
                      return (
                        <Link href={`/project/${item.seo_url}`}>
                          <a>
                            <div className="item">
                              <div className="box">
                                <div className="image">
                                  <img src={item.logo} alt="" />
                                </div>
                                <div className="content">
                                  <h3>{item.name}</h3>
                                  <p>{item.description}</p>
                                </div>
                              </div>
                            </div>
                          </a>
                        </Link>
                      );
                    })
                  : false}
              </Slider>
            </div>
          </div>
        </div>
        <div className="r-archivement">
          <div className="container">
            <div className="title-center">
              <h3>{trans.about.achievement_title}</h3>
              <p>{trans.home.achievement_feature_des}</p>
            </div>
            <div className="row">
              <div className="col-6 col-md-3">
                <div className="box box-1">
                  <div className="icon">
                    <img
                      src="/assets/images/home/archivement-icon-1.png"
                      alt=""
                    />
                  </div>
                  <h2>500+</h2>
                  <p>{trans.home.project}</p>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="box box-2">
                  <div className="icon">
                    <img
                      src="/assets/images/home/archivement-icon-2.png"
                      alt=""
                    />
                  </div>
                  <h2>200+</h2>
                  <p>{trans.home.customer}</p>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="box box-3">
                  <div className="icon">
                    <img
                      src="/assets/images/home/archivement-icon-3.png"
                      alt=""
                    />
                  </div>
                  <h2>100+</h2>
                  <p>{trans.home.engineer}</p>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="box box-4">
                  <div className="icon">
                    <img
                      src="/assets/images/home/archivement-icon-4.png"
                      alt=""
                    />
                  </div>
                  <h2>10+</h2>
                  <p>{trans.home.expert}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='r-recruitment'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 col-lg-4 col-left'>
                <div className='image'>
                  <img src='/assets/images/home/img-recruitment.png' alt='' />
                </div>
              </div>
              <div className='col-12 col-lg-8 col-right'>
                <div className='title-left'>
                  <h3>{trans.home.job}</h3>
                  <p className='desc'>{trans.home.job_des}
                  </p>
                  <Link href={'/recruitment'}>
                    <a className='link'>
                      <svg width={107} height={54} viewBox='0 0 107 54' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path fillRule='evenodd' clipRule='evenodd' d='M106.021 29.2216C106.546 28.697 106.841 27.9854 106.841 27.2435C106.841 26.5016 106.546 25.7901 106.021 25.2655L82.2846 1.52874C81.76 1.00413 81.0485 0.709405 80.3065 0.709406C79.5646 0.709407 78.8531 1.00413 78.3285 1.52874C77.8039 2.05336 77.5091 2.76489 77.5091 3.5068C77.5091 4.24872 77.8039 4.96025 78.3285 5.48486L97.2902 24.4465L3.00861 24.4426C2.64079 24.4426 2.27657 24.515 1.93674 24.6558C1.59691 24.7966 1.28814 25.0029 1.02805 25.263C0.76796 25.5231 0.561645 25.8318 0.420883 26.1717C0.28012 26.5115 0.20768 26.8757 0.207678 27.2435C0.207676 27.6113 0.280125 27.9756 0.420884 28.3154C0.561642 28.6552 0.767962 28.964 1.02805 29.2241C1.28814 29.4842 1.59691 29.6905 1.93674 29.8312C2.27656 29.972 2.64079 30.0445 3.00861 30.0445L97.2902 30.0405L78.3285 49.0022C77.8039 49.5268 77.5091 50.2383 77.5091 50.9802C77.5091 51.7222 77.8039 52.4337 78.3285 52.9583C78.8531 53.4829 79.5646 53.7776 80.3065 53.7776C81.0485 53.7776 81.76 53.4829 82.2846 52.9583L106.021 29.2216Z' fill='#0063AA' />
                      </svg>
                    </a>
                  </Link>
                </div>
                <div className='job-list'>
                  {list_job.map((item) => {
                    return (
                      <Link href={`/recruitment/${item.url}`}>
                        <div className='box'>
                          <div className='check'>
                            <svg width={34} height={26} viewBox='0 0 34 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
                              <path d='M10.463 20.7989L3.463 13.7989C3.27996 13.6137 3.06196 13.4666 2.82164 13.3662C2.58131 13.2658 2.32345 13.2141 2.063 13.2141C1.80255 13.2141 1.54469 13.2658 1.30437 13.3662C1.06405 13.4666 0.84605 13.6137 0.663004 13.7989C0.477724 13.982 0.330621 14.2 0.230222 14.4403C0.129823 14.6806 0.078125 14.9385 0.078125 15.1989C0.078125 15.4594 0.129823 15.7172 0.230222 15.9576C0.330621 16.1979 0.477724 16.4159 0.663004 16.5989L9.043 24.9789C9.823 25.7589 11.083 25.7589 11.863 24.9789L33.063 3.79894C33.2483 3.61589 33.3954 3.39789 33.4958 3.15757C33.5962 2.91725 33.6479 2.65939 33.6479 2.39894C33.6479 2.13849 33.5962 1.88063 33.4958 1.64031C33.3954 1.39999 33.2483 1.18199 33.063 0.998941C32.88 0.813662 32.662 0.666558 32.4216 0.566159C32.1813 0.46576 31.9235 0.414062 31.663 0.414062C31.4026 0.414062 31.1447 0.46576 30.9044 0.566159C30.6641 0.666558 30.4461 0.813662 30.263 0.998941L10.463 20.7989Z' fill='white' />
                            </svg>
                          </div>
                          <div className='group-content'>
                            <div className='title'>
                              <h2>{item.text_under}</h2>
                            </div>
                            <div className='content'>
                              <h3>{item.title}</h3>
                              <ul>
                                <li>
                                  <div className='name'>給料</div>
                                  <div className='value'>{formatSalary(item)}</div>
                                </li>
                                <li>
                                  <div className='name'>位置</div>
                                  <div className='value'>{item.address_detail}</div>
                                </li>
                              </ul>
                            </div>
                          </div>

                        </div>
                      </Link>

                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="r-office-tcom">
          <div className="container-fluid">
            <div className="row">
              <div className="co l-12 col-xl-3 col-left">
                {/* <div class="circle circle-1"></div> */}
                <div className="circle circle-2" />
                <div className="circle circle-3" />
                <div className="inner">
                  {/* dung0510 */}
                  {/* <p>{trans.home.image} &amp; ビデオ</p> */}
                  {/* dung0510 */}
                  <h3>{trans.home.office}</h3>
                  {/* <h3>{trans.home.office1}</h3>
                  <h3>{trans.home.office2}</h3> */}
                  {/* <a href='#' className='btn-start'>
                    Xem video
                    <svg width={40} height={40} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M20 2.5C10.3359 2.5 2.5 10.3359 2.5 20C2.5 29.6641 10.3359 37.5 20 37.5C29.6641 37.5 37.5 29.6641 37.5 20C37.5 10.3359 29.6641 2.5 20 2.5ZM25.6289 20.2695L17.0977 26.4766C17.0509 26.5102 16.9958 26.5302 16.9383 26.5346C16.8809 26.5389 16.8234 26.5273 16.7721 26.501C16.7208 26.4748 16.6778 26.4349 16.6477 26.3858C16.6176 26.3367 16.6017 26.2803 16.6016 26.2227V13.8164C16.6014 13.7587 16.6172 13.7021 16.6472 13.6528C16.6772 13.6035 16.7203 13.5635 16.7717 13.5372C16.8231 13.5109 16.8807 13.4994 16.9382 13.5038C16.9958 13.5083 17.051 13.5286 17.0977 13.5625L25.6289 19.7656C25.6692 19.7941 25.7021 19.8319 25.7248 19.8757C25.7475 19.9196 25.7593 19.9682 25.7593 20.0176C25.7593 20.0669 25.7475 20.1156 25.7248 20.1594C25.7021 20.2033 25.6692 20.241 25.6289 20.2695Z' fill='#0063AA' />
                    </svg>
                  </a> */}
                  <a
                    ref={refClickYoutobe}
                    onClick={() => setIsShowModal(true)}
                    className="btn-start"
                  >
                    {trans.home.start}
                    <svg
                      width={40}
                      height={40}
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 2.5C10.3359 2.5 2.5 10.3359 2.5 20C2.5 29.6641 10.3359 37.5 20 37.5C29.6641 37.5 37.5 29.6641 37.5 20C37.5 10.3359 29.6641 2.5 20 2.5ZM25.6289 20.2695L17.0977 26.4766C17.0509 26.5102 16.9958 26.5302 16.9383 26.5346C16.8809 26.5389 16.8234 26.5273 16.7721 26.501C16.7208 26.4748 16.6778 26.4349 16.6477 26.3858C16.6176 26.3367 16.6017 26.2803 16.6016 26.2227V13.8164C16.6014 13.7587 16.6172 13.7021 16.6472 13.6528C16.6772 13.6035 16.7203 13.5635 16.7717 13.5372C16.8231 13.5109 16.8807 13.4994 16.9382 13.5038C16.9958 13.5083 17.051 13.5286 17.0977 13.5625L25.6289 19.7656C25.6692 19.7941 25.7021 19.8319 25.7248 19.8757C25.7475 19.9196 25.7593 19.9682 25.7593 20.0176C25.7593 20.0669 25.7475 20.1156 25.7248 20.1594C25.7021 20.2033 25.6692 20.241 25.6289 20.2695Z"
                        fill="#0063AA"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="col-12 col-xl-9 col-right">
                <div className="tcom-image">
                  <Slider {...setting_office}>
                    {list_image_office.map(item => {
                      return (
                        <div className="item">
                          <img src={item.url} alt="" />
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
            {isShowModal && (
              <div className="c-lightbox-video ">
                <div className="c-lightbox-video__transaction"></div>
                <div className="c-lightbox-video__inner">
                  <div
                    ref={refYoutobe}
                    className="c-lightbox-video__inner__form"
                  >
                    <iframe
                      width="100%"
                      height="600"
                      src="https://www.youtube.com/embed/elZzejeEeSo?autoplay=1"
                      title="YouTube video player"
                      frameBorder={0}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="r-news">
          <div className="container">
            <div className="title-left">
              {/* dung */}
              {/* <h3>{trans.home.news}</h3> */}
              <h3>ニュース・イベント</h3>
              {/* dung */}
              {/* <p className='desc'>{trans.home.news_des}</p> */}
              <Link href={'/news'}>
                <a className="link">
                  <svg
                    width={107}
                    height={54}
                    viewBox="0 0 107 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M106.021 29.2216C106.546 28.697 106.841 27.9854 106.841 27.2435C106.841 26.5016 106.546 25.7901 106.021 25.2655L82.2846 1.52874C81.76 1.00413 81.0485 0.709405 80.3065 0.709406C79.5646 0.709407 78.8531 1.00413 78.3285 1.52874C77.8039 2.05336 77.5091 2.76489 77.5091 3.5068C77.5091 4.24872 77.8039 4.96025 78.3285 5.48486L97.2902 24.4465L3.00861 24.4426C2.64079 24.4426 2.27657 24.515 1.93674 24.6558C1.59691 24.7966 1.28814 25.0029 1.02805 25.263C0.76796 25.5231 0.561645 25.8318 0.420883 26.1717C0.28012 26.5115 0.20768 26.8757 0.207678 27.2435C0.207676 27.6113 0.280125 27.9756 0.420884 28.3154C0.561642 28.6552 0.767962 28.964 1.02805 29.2241C1.28814 29.4842 1.59691 29.6905 1.93674 29.8312C2.27656 29.972 2.64079 30.0445 3.00861 30.0445L97.2902 30.0405L78.3285 49.0022C77.8039 49.5268 77.5091 50.2383 77.5091 50.9802C77.5091 51.7222 77.8039 52.4337 78.3285 52.9583C78.8531 53.4829 79.5646 53.7776 80.3065 53.7776C81.0485 53.7776 81.76 53.4829 82.2846 52.9583L106.021 29.2216Z"
                      fill="#0063AA"
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <ul className="list">
              {list_new_post.map((item, index) => {
                return (
                  <li>
                    <Link href={`/news/${item.seo_url}`}>
                      <a>
                        <div className="image">
                          <img
                            style={{
                              maxHeight: 263,
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                            src={item.image}
                            alt=""
                          />
                        </div>
                      </a>
                    </Link>
                    <div className="content">
                      <div className="type">
                        <p className="date">
                          {moment(item?.show_date || item?.createdAt).format(
                            'YYYY/MM/DD',
                          )}
                        </p>
                        <span>{item.postcategory.name}</span>
                      </div>
                      <Link href={`/news/${item.seo_url}`}>
                        <a>
                          <p className="title">{item.title}</p>
                          <Link href={`/news/${item.seo_url}`}>
                            <a className="handle">
                              <span>続きを読む</span>
                              <svg
                                width={35}
                                height={18}
                                viewBox="0 0 35 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M33.8622 9.77818C34.0256 9.61475 34.1174 9.39309 34.1174 9.16197C34.1174 8.93084 34.0256 8.70918 33.8622 8.54575L26.4676 1.1512C26.3042 0.987768 26.0825 0.895955 25.8514 0.895955C25.6203 0.895954 25.3986 0.987768 25.2352 1.1512C25.0717 1.31463 24.9799 1.53629 24.9799 1.76741C24.9799 1.99854 25.0717 2.22019 25.2352 2.38362L31.1422 8.29064L1.77123 8.28941C1.65665 8.28941 1.54318 8.31198 1.43732 8.35583C1.33146 8.39968 1.23527 8.46395 1.15424 8.54498C1.07322 8.626 1.00894 8.72219 0.965095 8.82805C0.921245 8.93392 0.898677 9.04738 0.898677 9.16197C0.898676 9.27655 0.921246 9.39002 0.965095 9.49588C1.00895 9.60175 1.07322 9.69793 1.15424 9.77896C1.23527 9.85998 1.33146 9.92426 1.43732 9.96811C1.54318 10.012 1.65665 10.0345 1.77124 10.0345L31.1422 10.0333L25.2352 15.9403C25.0717 16.1037 24.9799 16.3254 24.9799 16.5565C24.9799 16.7876 25.0717 17.0093 25.2352 17.1727C25.3986 17.3362 25.6203 17.428 25.8514 17.428C26.0825 17.428 26.3042 17.3362 26.4676 17.1727L33.8622 9.77818Z"
                                  fill="#0063AA"
                                />
                              </svg>
                            </a>
                          </Link>
                        </a>
                      </Link>
                    </div>
                  </li>
                );
              })}
            </ul>
            <div className="btnMoreNews">
              <Link href={'/news'}>
                <a className="handleBtnMore">
                  <span>続きを読む</span>
                  <svg
                    width="34"
                    height="18"
                    viewBox="0 0 34 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M33.3248 9.58678C33.4882 9.42335 33.5801 9.20169 33.5801 8.97056C33.5801 8.73944 33.4882 8.51778 33.3248 8.35435L25.9303 0.959791C25.7668 0.796362 25.5452 0.704549 25.314 0.704548C25.0829 0.704548 24.8613 0.796361 24.6978 0.959791C24.5344 1.12322 24.4426 1.34488 24.4426 1.57601C24.4426 1.80713 24.5344 2.02879 24.6978 2.19222L30.6048 8.09924L1.23388 8.098C1.1193 8.098 1.00583 8.12057 0.899967 8.16442C0.794103 8.20827 0.697913 8.27255 0.616889 8.35357C0.535864 8.43459 0.471591 8.53078 0.427741 8.63665C0.383891 8.74251 0.361324 8.85597 0.361324 8.97056C0.361323 9.08515 0.383892 9.19861 0.427741 9.30448C0.471592 9.41034 0.535865 9.50653 0.616889 9.58755C0.697914 9.66858 0.794103 9.73285 0.899966 9.7767C1.00583 9.82055 1.11929 9.84312 1.23388 9.84312L30.6048 9.84189L24.6978 15.7489C24.5344 15.9123 24.4426 16.134 24.4426 16.3651C24.4426 16.5962 24.5344 16.8179 24.6978 16.9813C24.8613 17.1448 25.0829 17.2366 25.314 17.2366C25.5452 17.2366 25.7668 17.1448 25.9303 16.9813L33.3248 9.58678Z"
                      fill="#0063AA"
                    />
                  </svg>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
